import { FormConfig } from '../edit-create-form.interfaces';

export const shiftSettingFormConfig = (): FormConfig => {
  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'code', label: 'Mã ca', required: true, width: 'half',
        type: 'text', placeholder: 'Nhập mã ca',
        disabled: (editMode) => editMode
      },
      {
        key: 'name', label: 'Tên ca', required: true, width: 'half',
        type: 'text', placeholder: 'Nhập tên ca'
      },
      {
        key: 'from', label: 'Từ giờ', required: true, width: 'half',
        type: 'datepicker', placeholder: 'Chọn giờ bắt đầu',
        datePickerMode: 'time'
      },
      {
        key: 'to', label: 'Đến giờ', required: true, width: 'half',
        type: 'datepicker', placeholder: 'Chọn giờ kết thúc',
        datePickerMode: 'time'
      }
    ]
  };
};
